import { render, staticRenderFns } from "./competency-role.vue?vue&type=template&id=36e2a160&scoped=true"
import script from "./competency-role.vue?vue&type=script&lang=js"
export * from "./competency-role.vue?vue&type=script&lang=js"
import style0 from "./competency-role.vue?vue&type=style&index=0&id=36e2a160&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36e2a160",
  null
  
)

export default component.exports